import React from 'react';

import TextBlock, { TextBlockProps } from '../TextBlock';
import AccordionListItem, {
  AccordionListItemProps,
} from '../AccordionListItem';

import styles from './index.module.scss';

export interface TextWithAccordionListItemsCardProps {
  textBlock: TextBlockProps;
  accordionListItems: AccordionListItemProps[];
}

const TextWithAccordionListItemsCard: React.FC<
  TextWithAccordionListItemsCardProps
> = ({ textBlock, accordionListItems }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.textBlock}>
        <TextBlock {...textBlock} />
      </div>
      <ul className={styles.accordionsWrapper}>
        {accordionListItems.map((item, index) => (
          <AccordionListItem
            key={item.title}
            {...item}
            className={styles.accordionItem}
            isOpenByDefault={index === 0}
          />
        ))}
      </ul>
    </div>
  );
};

export default TextWithAccordionListItemsCard;
